import React from 'react'

import * as Form from 'modules/plan/components/Form'
import * as Layout from '../Layout/Section'

import * as styles from './styles.module.scss'

/**
 */
export const SelectRoomPlan = ({ propertyType }) => (
  <Layout.Container>
    <Layout.Title>Kitchen Style</Layout.Title>
    <Layout.Description>キッチンスタイルをお選びください。</Layout.Description>
    <Layout.Content>
      <Form.Fields.RoomPlan styles={styles} />
    </Layout.Content>
  </Layout.Container>
)
